import type { ColorName } from '@frontend/constants';
import { match } from '@frontend/duck-tape';
import { Text, XStack, YStack } from '@frontend/web-react';

type InlineAlertVariant = 'error';

type InlineAlertProps = {
  description: string;
  variant: InlineAlertVariant;
};

export const InlineAlert = ({ description, variant }: InlineAlertProps) => {
  const dotColor = match<InlineAlertVariant, ColorName>(variant)
    .with('error', () => 'rose400')
    .exhaustive();

  return (
    <XStack className="gap-x-sm p-xs rounded-md">
      <XStack>
        <YStack bg={dotColor} m="xs" mt="xs" radius="xxxl" style={{ height: 12, width: 12 }} />
      </XStack>
      <YStack>
        <Text color="secondary" type="p-sm">
          {description}
        </Text>
      </YStack>
    </XStack>
  );
};
